<template>
  <div>
    <h3 class="text-sm font-medium text-gray-900 dark:text-gray-100 mb-4">
      Select Competitors to Analyze
    </h3>

    <div v-if="organicResults.length === 0" class="text-center py-6">
      <p class="text-gray-500 dark:text-gray-400">
        No organic results available. Run SERP Analysis first.
      </p>
    </div>

    <div v-else class="space-y-2 mb-6">
      <label
        v-for="result in organicResults"
        :key="result.link"
        class="flex items-start gap-3 p-3 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer">
        <input
          type="checkbox"
          :value="result.link"
          v-model="selectedUrls"
          class="mt-1 rounded border-gray-300">
        <div class="flex-1 min-w-0">
          <div class="text-sm font-medium text-gray-900 dark:text-gray-100 truncate">{{ result.title }}</div>
          <div class="text-xs text-gray-500 dark:text-gray-400 truncate">{{ result.link }}</div>
          <div class="text-xs text-gray-400 mt-0.5">#{{ result.position }} &middot; {{ extractDomain(result.link) }}</div>
        </div>
      </label>
    </div>

    <div class="flex items-center justify-between">
      <span class="text-sm text-gray-500">{{ selectedUrls.length }} competitors selected</span>
      <button
        @click="$emit('start', selectedUrls)"
        :disabled="selectedUrls.length === 0"
        class="inline-flex items-center px-4 py-2 bg-green-500 hover:bg-green-600 text-white rounded-lg font-medium text-sm transition-colors disabled:opacity-50">
        Start Analysis
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  serpAnalysis: { type: Object, required: true }
})

defineEmits(['start'])

const EXCLUDED_DOMAINS = ['wikipedia.org', 'youtube.com', 'yelp.com', 'facebook.com', 'twitter.com', 'instagram.com', 'pinterest.com', 'reddit.com', 'linkedin.com', 'bbb.org', 'yellowpages.com', 'amazon.com']

const extractDomain = (url) => {
  try { return new URL(url).hostname.replace(/^www\./, '') } catch { return url }
}

const organicResults = computed(() => {
  const results = props.serpAnalysis?.raw_serp_data?.organic_results || []
  return results.filter((r) => {
    const domain = extractDomain(r.link || '')
    return !EXCLUDED_DOMAINS.some((d) => domain.includes(d))
  })
})

const selectedUrls = ref(organicResults.value.slice(0, 7).map((r) => r.link))
</script>
